import CrossIcon from '../svg/CrossIcon'
import InfoIcon from '../svg/InfoIcon'

function InfoPopUp({popUpMessage, setPopUpMessage }) {

  function closePopUp() {
    setPopUpMessage(null)
  }

  return (
    <div className='infoPopUp'>
        <div className='box'>
          <InfoIcon/>
          <div>{popUpMessage}</div>
          <span className='spanIcon' onClick={()=>closePopUp()}><CrossIcon/></span>
        </div>
    </div>
  )
}

export default InfoPopUp